export const AdminTableconstant = {
  ADMIN_TABLE_SAGA: "ADMIN_TABLE_SAGA",
  ADMIN_TABLE_REQUEST: "ADMIN_TABLE_REQUEST",
  ADMIN_TABLE_RESPONSE: "ADMIN_TABLE_RESPONSE",
  ADMIN_TABLE_API: "/vendors",
};
